import React, { Fragment, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'components/common/translations/Translate';
import classNames from 'classnames';
import airplane from 'components/assets/img/icons/airplane.svg';
import Rating from 'react-rating';
import starEmpty from 'components/assets/img/icons/star-empty.svg';
import starFull from 'components/assets/img/icons/star-full.svg';

function TripItem(props) {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');
  const content = useRef(null);

  function toggleAccordion() {
    setActiveState(setActive === '' ? 'list-trips__item--active' : '');
    setHeightState(
      setActive === 'list-trips__item--active' ? '0' : `${content.current.scrollHeight}px`
    );
  }

  function handleInvoiceClick(e) {
    e.stopPropagation();
  }

  return (
    <Fragment>
      <li className={`list-trips__item ${setActive}`} onClick={toggleAccordion}>
        <div className="list-trips__header">
          <div className={classNames(
            'list-trips__status', {
            'list-trips__status--success': props.complete
          })}>
            <FontAwesomeIcon icon={props.icon} />
            {props.status}
          </div>

          <div className="list-trips__date">
            {props.data}
          </div>

          <div className="list-trips__data">
            {props.addressFirst && (
              <span className="list-trips__sep--right">
                <span>{props.address}</span>
                <FontAwesomeIcon
                  icon="shuttle-van"
                />
              </span>
            )}

            <span>{props.departure}</span>
            <img src={airplane} />
            <span>{props.arrival}</span>
            {props.addressSecond && (
              <span className="list-trips__sep--left">
                <FontAwesomeIcon
                  icon="shuttle-van"
                />
                <span>{props.address}</span>
              </span>
            )}
          </div>

          <div className="list-trips__invoice">
            {props.invoice == true &&
              <a
                onClick={handleInvoiceClick}
                href={`/download-invoice/${props.invoiceHash}`}
                title={props.trans('content.dashboard.getInvoice')}
              >
                <i className="ic--invoice"></i>
                <span><T>content.dashboard.getInvoice</T></span>
              </a>
            }
          </div>

          <div className="list-trips__rating">
            {props.canSeeRating && (
              <Rating
                emptySymbol={<img src={starEmpty} className="rating__icon" />}
                fullSymbol={<img src={starFull} className="rating__icon" />}
                readonly={true}
                initialRating={props.rating}
              />
            )}
            {props.canRateTrip && (
              props.reviewLink
            )}
          </div>

          <div className="list-trips__more">
            <FontAwesomeIcon
              icon="angle-down"
            />
          </div>
        </div>

        <div
          className="list-trips__desc"
          ref={content}
          style={{ maxHeight: `${setHeight}` }}
        >
          <ul>
            <li>
              <FontAwesomeIcon
                icon="users"
              />
              <span><T>content.common.adults</T>:</span> {props.adults}
            </li>

            <li>
              <span><T>content.common.students</T>:</span> {props.students}
            </li>

            <li>
              <span><T>content.common.kids</T>:</span> {props.children}
            </li>

            <li>
              <FontAwesomeIcon
                icon="credit-card"
              />
              <span><T>content.common.price</T>:</span> {parseFloat(props.price)}{' '}
              <span className="currency">NOK</span>{' '}
              {props.paymentToDriver && (
                <em>(<T>content.dashboard.payToDriver</T>)</em>
              )}
            </li>
          </ul>

        </div>
      </li>
    </Fragment>
  );
}

export default TripItem;
